import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doGet } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const LogoutAction = createAsyncThunk("logout",
    async (_, { rejectWithValue }) => {
        try {
            const response = await doGet(urls.logout);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    })

const LogoutSlice = createSlice({
    name: 'logout',
    initialState: {
        isLoading: false,
        logout: {},
        error: null,
        success: false
    },
    reducers: {
        LogoutReset: () => {
            return {
                isLoading: false,
                logout: false,
                error: null,
                success: false,
            }
        }
    },
    extraReducers: {
        [LogoutAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [LogoutAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.logout = payload;
            state.error = null;
            state.success = true;
        },
        [LogoutAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        }
    }
})

export const { LogoutReset } = LogoutSlice.actions;
export default LogoutSlice.reducer;